import routerOptions0 from "/apps/web/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_7877e1059fd6beb6dc82ce05aa3e1262/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}